import React from "react";
import {
	Box,
	Divider,
	Grid,
	NavigationBar,
	ResponsiveLayout,
	useScreenSize,
	useWindowHeight,
} from "@telefonica/mistica";
import { ReactComponent as NavBarLogoPay } from "../../assets/icons/navBarLogoPay.svg";
import { Footer } from "../Footer";
import { HEIGHT_GRID_LOGO } from "../../enum/heightGridLogo";
import { observer } from "mobx-react-lite";

interface IProps {
	children: React.ReactNode;
	navigationTitle?: string;
	isLogo?: boolean;
	isFooter?: boolean;
	responsiveLayoutProps?: {
		backgroundColor?: string;
	};
	isFullHeight?: boolean;
	onBack?(): void;
}

export const ScreenResponsive: React.FC<IProps> = observer(
	({
		children,
		isLogo = true,
		isFooter = true,
		navigationTitle,
		onBack,
		responsiveLayoutProps,
		isFullHeight = false,
	}) => {
		const { isDesktopOrBigger } = useScreenSize();
		const screenHeight = useWindowHeight();

		const navigationBarHeight = !navigationTitle ? 0 : isDesktopOrBigger ? 76 : 56;
		const navigationBarPadding = isDesktopOrBigger ? 24 : 16;

		return (
			<Box>
				{isLogo && (
					<Box>
						<Box paddingLeft={72} paddingRight={72}>
							<Grid
								height={HEIGHT_GRID_LOGO}
								alignItems="center"
								justifyItems={isDesktopOrBigger ? "start" : "center"}
								rows={1}
								columns={1}
							>
								<Box paddingLeft={isDesktopOrBigger ? 32 : 0}>
									<NavBarLogoPay />
								</Box>
							</Grid>
						</Box>
						<Divider />
					</Box>
				)}

				{navigationTitle && (
					<Grid height={navigationBarHeight}>
						<Box paddingLeft={navigationBarPadding}>
							<NavigationBar title={navigationTitle} onBack={onBack} withBorder={false} topFixed={false} />
						</Box>
						<Divider />
					</Grid>
				)}

				<Grid minHeight={isFullHeight ? screenHeight - navigationBarHeight - HEIGHT_GRID_LOGO : "100%"}>
					<ResponsiveLayout {...responsiveLayoutProps}>{children}</ResponsiveLayout>
				</Grid>
				{isFooter && <Footer />}
			</Box>
		);
	},
);
